// Core
import React, {useState} from "react"
import TransitionLink from 'gatsby-plugin-transition-link'

// Components
import MenuBtn from "../menuBtn"
import AudioToggle from "../audioToggle"

// Styles
import styles from "./mobileMenu.module.scss"

// Data
import pages from "./../../data/pages"

const MobileMenuItem = ({index, title, slug, label, current, leaveEvent, closeEvent}) => {

  if (title === "Credits") return false

  return (
    <li className={`${styles.item} ${current ? styles.current : ""}`}>
      <TransitionLink
        aria-label={label}
        to={"/" + slug}
        onClick={closeEvent}
        exit={{
          trigger: leaveEvent,
          length: ((index === 9) ? 0 : 6),
          zIndex: 5
        }}
        entry={{
          delay: 0,
          zIndex: 10
        }}
        >
        {title}
      </TransitionLink>
    </li>
  )
}

const MobileMenu = ({index, leaveEvent}) => {
  const [open, setOpen] = useState(false)

  return (
    <div className={`${styles.mobileMenu} ${open ? styles.open : ""}`}>
      <MenuBtn open={open} event={setOpen} />
      <div className={styles.menu}>
        <div className={`container`}>
          <div className={styles.inner}>
            <ul className={styles.primaryMenu}>
              <li>
                <TransitionLink
                  to={"/"}
                  exit={{
                    trigger: leaveEvent,
                    length: 0,
                    zIndex: 5
                  }}
                  entry={{
                    delay: 0,
                    zIndex: 10
                  }}
                  >
                  Home
                </TransitionLink>
              </li>
            </ul>
            <ul className={styles.secondaryMenu}>
              {
                pages.map((page) =>
                  <MobileMenuItem key={`mobile-menu-item-${page.index}`} {...page} current={index === page.index} leaveEvent={leaveEvent} closeEvent={() => setOpen(false)} />
                )
              }
            </ul>
            <ul className={styles.primaryMenu}>
              <li>
                <TransitionLink
                  to={"/credits"}
                  exit={{
                    trigger: leaveEvent,
                    length: 0,
                    zIndex: 5
                  }}
                  entry={{
                    delay: 0,
                    zIndex: 10
                  }}
                  >
                  Credits
                </TransitionLink>
              </li>
            </ul>
            <div className={styles.audioSwitch}>
              <AudioToggle />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MobileMenu